import Edit02Icon from "@/components/shared/icons/Edit02Icon";
import { ToastSuccess } from "@/components/shared/toast/Toast";
import {
  CButton,
  CFormCheck,
  CFormInput,
  CFormSwitch,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSmartTable,
} from "@coreui/react-pro";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { IUser } from "../../../shared/model/user.model";
import {
  createIndexes,
  formatVNDNoDecimals,
} from "../../../shared/utils/ultils";
import { AppDispatch } from "../../../store";
import CustomTableFooter from "../../shared/CustomTableFooter/CustomTableFooter";
import {
  userSelectors,
  fetching,
  resetEntity,
  setFilterState,
} from "./userManagement.reducer";
import {
  getEntities,
  updateEntity,
  updateEntityStatus,
} from "./userManagement.api";
import UserUpdate from "./UserUpdate";
import {
  ResponseStatus,
  ResponseStatusUser,
} from "@/shared/enumeration/ResponseStatus";
import SearchDebounce from "@/components/shared/searchDebounce/SearchDebounce";
import { socket } from "@/shared/config/socket";

const columns = [
  {
    key: "id",
    label: "ID",
    sorter: false,
  },
  {
    key: "username",
    label: "Thông tin",
    sorter: false,
  },
  {
    key: "gao",
    label: "Gạo",
    sorter: false,
  },
  {
    key: "luamy",
    label: "Lúa mỳ",
    sorter: false,
  },

  {
    key: "coffee",
    label: "Coffee",
    sorter: false,
  },

  {
    key: "daunanh",
    label: "Đậu Nành",
    sorter: false,
  },

  {
    key: "vang",
    label: "Vàng",
    sorter: false,
  },

  {
    key: "bac",
    label: "Bạc",
    sorter: false,
  },

  {
    key: "platinum",
    label: "Platinum",
    sorter: false,
  },

  {
    key: "titanium",
    label: "Titanium",
    sorter: false,
  },

  {
    key: "dau",
    label: "Dầu",
    sorter: false,
  },

  {
    key: "uranium",
    label: "Uranium",
    sorter: false,
  },
  {
    key: "gas",
    label: "Gas",
    sorter: false,
  },
  // {
  //   key: "actions",
  //   label: "Thao tác",
  //   sorter: false,
  //   _props: { className: "text-center" },
  // },
];

interface IIndexUser extends IUser {
  index: number;
}

const UserManagement = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { initialState } = useSelector(
    (state: RootState) => state.usersReducer
  );
  const {
    filterState,
    totalItems,
    totalPages,
    loading,
    updateEntitySuccess,
    deleteEntitySuccess,
  } = initialState;
  const [createUser, setCreateUser] = useState<boolean>(false);
  const [updateUser, setUpdateUser] = useState<IUser | null>(null);

  const handleCreateUser = () => {
    setCreateUser(true);
  };

  const handleUpdateUser = (user: IUser) => () => {
    setUpdateUser(user);
  };

  const handleCancelUpdateUser = (update?: boolean) => {
    setUpdateUser(null);
  };

  const handlePaginationChange = (page: number) => {
    window.scrollTo(0, 0);
    handleFilterStateChange(page, "page");
  };

  const users = useSelector(userSelectors.selectAll);
  const indexedUser = createIndexes(users, filterState);

  const handleUpdate = (user: IUser, valueOld: any, key: string) => () => {
    const status =
      valueOld === ResponseStatusUser.ACTIVE
        ? ResponseStatusUser.INACTIVE
        : ResponseStatusUser.ACTIVE;
    dispatch(fetching());
    dispatch(updateEntityStatus({ ...user, [key]: status }));
    socket.emit("send_event", {
      event: `update_user_${user?.id}`,
      body: {
        [key]: status,
      },
    });
  };

  useEffect(() => {
    if (updateEntitySuccess && !createUser && !updateUser) {
      ToastSuccess("Cập nhật 2.10 thành công");
      dispatch(resetEntity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEntitySuccess]);

  useEffect(() => {
    if (!deleteEntitySuccess) {
      dispatch(fetching());
      dispatch(getEntities(filterState));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filterState), deleteEntitySuccess]);

  useEffect(() => {
    if (deleteEntitySuccess) {
      ToastSuccess("Xoá ngân hàng thành công");
      dispatch(resetEntity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteEntitySuccess]);

  const onSearch = () => {
    dispatch(getEntities({ ...filterState }));
  };

  const handleFilterStateChange = <T,>(value: T, name: string) => {
    dispatch(setFilterState({ ...filterState, page: 1, [name]: value }));
  };

  return (
    <>
      <div className="tab-outlet-content">
        <div className="table-context flex-column justify-content-start align-items-start gap-3 pb-3">
          <div className="d-flex">
            <SearchDebounce
              value={filterState?.keyword}
              name="keyword"
              setSearchKeyword={(value: string, name: string) =>
                handleFilterStateChange(value?.trim(), name)
              }
              placeholder="ID hoặc Tên thành viên"
              delay={500}
              style={{ width: 250, height: 42 }}
            />
            <CButton
              style={{ height: 42, whiteSpace: "nowrap" }}
              className="ms-2 btn-custom btn-sm text-white"
              onClick={onSearch}
            >
              Tìm kiếm
            </CButton>
          </div>
          <div className="d-flex gap-3">
            <CFormCheck
              type="checkbox"
              label="Gạo"
              name="gao"
              id="gao"
              checked={filterState.gao === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.gao === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "gao"
                )
              }
            />

            <CFormCheck
              type="checkbox"
              label="Lúa mỳ"
              name="luamy"
              id="luamy"
              checked={filterState.luamy === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.luamy === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "luamy"
                )
              }
            />

            <CFormCheck
              type="checkbox"
              label="Coffee"
              name="coffee"
              id="coffee"
              checked={filterState.coffee === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.coffee === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "coffee"
                )
              }
            />

            <CFormCheck
              type="checkbox"
              label="Đậu Nành"
              name="daunanh"
              id="daunanh"
              checked={filterState.daunanh === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.daunanh === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "daunanh"
                )
              }
            />

            <CFormCheck
              type="checkbox"
              label="Vàng"
              name="vang"
              id="vang"
              checked={filterState.vang === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.vang === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "vang"
                )
              }
            />

            <CFormCheck
              type="checkbox"
              label="Bạc"
              name="bac"
              id="bac"
              checked={filterState.bac === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.bac === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "bac"
                )
              }
            />

            <CFormCheck
              type="checkbox"
              label="Platinum"
              name="platinum"
              id="platinum"
              checked={filterState.platinum === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.platinum === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "platinum"
                )
              }
            />

            <CFormCheck
              type="checkbox"
              label="Titanium"
              name="titanium"
              id="titanium"
              checked={filterState.titanium === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.titanium === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "titanium"
                )
              }
            />

            <CFormCheck
              type="checkbox"
              label="Dầu"
              name="dau"
              id="dau"
              checked={filterState.dau === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.dau === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "dau"
                )
              }
            />

            <CFormCheck
              type="checkbox"
              label="Uranium"
              name="uranium"
              id="uranium"
              checked={filterState.uranium === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.uranium === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "uranium"
                )
              }
            />

            <CFormCheck
              type="checkbox"
              label="Gas"
              name="gas"
              id="gas"
              checked={filterState.gas === ResponseStatusUser.ACTIVE}
              onChange={() =>
                handleFilterStateChange(
                  filterState.gas === ResponseStatusUser.ACTIVE
                    ? null
                    : ResponseStatusUser.ACTIVE,
                  "gas"
                )
              }
            />
          </div>
        </div>

        <div className="table-content">
          <CSmartTable
            header
            columns={columns}
            items={indexedUser}
            clickableRows
            noItemsLabel="Không có bản ghi"
            itemsPerPage={filterState.limit}
            scopedColumns={{
              gao: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.gao === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.gao, "gao")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),
              luamy: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.luamy === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.luamy, "luamy")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),
              coffee: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.coffee === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.coffee, "coffee")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),
              daunanh: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.daunanh === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.daunanh, "daunanh")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),
              vang: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.vang === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.vang, "vang")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),
              bac: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.bac === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.bac, "bac")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),
              platinum: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.platinum === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.platinum, "platinum")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),
              titanium: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.titanium === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.titanium, "titanium")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),
              dau: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.dau === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.dau, "dau")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),
              uranium: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.uranium === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.uranium, "uranium")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),
              gas: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <CFormSwitch
                      checked={value.gas === ResponseStatusUser.ACTIVE}
                      className="me-2"
                      onChange={handleUpdate(value, value.gas, "gas")}
                      disabled={loading}
                    />
                  </div>
                </td>
              ),

              username: ({ index, ...value }: IIndexUser) => (
                <td>
                  <div className="d-flex flex-column gap-1">
                    <div>
                      Tên đăng nhập: <strong>{value.username}</strong>
                    </div>
                    <div>
                      Số dư:{" "}
                      <strong>{formatVNDNoDecimals(value.balance)}</strong>
                    </div>
                  </div>
                </td>
              ),
              actions: ({ index, ...value }: IIndexUser) => (
                <td>
                  <CInputGroup className="custom-input-group-action justify-content-center">
                    <CInputGroupText onClick={handleUpdateUser(value)}>
                      <Edit02Icon />
                    </CInputGroupText>
                  </CInputGroup>
                </td>
              ),
            }}
            tableProps={{
              hover: true,
              align: "middle",
              responsive: "lg",
              className: "custom-table",
            }}
            tableHeadProps={{
              className: "table-head",
            }}
            tableBodyProps={{
              className: "table-body",
            }}
          />
        </div>

        {createUser ? (
          <UserUpdate visible={createUser} setVisible={setCreateUser} />
        ) : (
          ""
        )}
        {updateUser ? (
          <UserUpdate
            visible={Boolean(updateUser)}
            userObj={updateUser}
            setVisible={handleCancelUpdateUser}
          />
        ) : (
          ""
        )}
        <CRow>
          <CustomTableFooter
            totalItems={totalItems}
            hideSideChosen
            totalPages={totalPages}
            filterState={filterState}
            setFilterState={(filter) => dispatch(setFilterState(filter))}
            handlePaginationChange={handlePaginationChange}
          />
        </CRow>
      </div>
    </>
  );
};

export default UserManagement;
